<template>
  <div class="uptime-chart">
    <canvas ref="uptime-chart-canvas"></canvas>
  </div>
</template>

<script setup lang="ts">
import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { onMounted, useTemplateRef } from 'vue'

import type { ScenarioClientWithUptime } from '/@front:types/shared'

const props = defineProps<{
  uptime: ScenarioClientWithUptime[]
}>()

const chartRef = useTemplateRef<HTMLCanvasElement>('uptime-chart-canvas')

const numberFormatter = new Intl.NumberFormat(document.documentElement.lang, {
  maximumFractionDigits: 1,
})

const dataLabelFormatter = (value: number | null) => {
  if (value === null) {
    return
  }

  return numberFormatter.format(value) + '%'
}

const initChart = () => {
  const element = chartRef.value as HTMLCanvasElement

  element.style.height = `${props.uptime.length * 60}px`

  new Chart(element, {
    type: 'bar',
    data: {
      labels: props.uptime.map((v) => v.client.title),
      datasets: [
        {
          data: props.uptime.map((v) => v.uptime),
          backgroundColor: '#00663a',
          borderWidth: 0,
          borderRadius: 4,
        },
      ],
    },
    plugins: [ChartDataLabels],
    options: {
      indexAxis: 'y',
      layout: {
        padding: {
          left: 20,
          right: 60,
          top: 20,
        },
      },
      datasets: {
        bar: {
          barPercentage: 0.2,
          categoryPercentage: 1.6,
        },
      },
      scales: {
        y: {
          grid: {
            display: false,
          },
          border: {
            display: false,
          },
        },
        x: {
          grid: {
            display: true,
          },
          ticks: {
            display: false,
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
        datalabels: {
          color: '#222',
          anchor: 'end',
          align: 'end',
          formatter: dataLabelFormatter,
          font: {
            lineHeight: 1.2,
          },
        },
      },
    },
  })
}

onMounted(() => {
  initChart()
})
</script>
